import { SxProps } from "@mui/material";

export const moreInfoBtnSx:SxProps = {
    width: 'fit-content',
    mt:1,
    py:0.5,
    px:3,
    border: '1px solid',
    borderRadius: 1,
    backgroundColor: '#fd0',
    fontWeight: 'bold',
}